<template>
	<div class="incenters">
		<div style="">
			<Commonbtn backgroundColor="#FFF" v-if="qx.add" title="新增" fontSize="14px" @btnclick="adduser"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.update" title="修改" fontSize="14px" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.enabled" title="停用" fontSize="14px" @btnclick="deactivate"
				:src="require('@/assets/icon/icon-stop.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.enabled" title="启用" fontSize="14px" @btnclick="Enable"
				:src="require('@/assets/icon/qy.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="proExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<CommonbtnUpLoad v-if="qx.add" style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF"
				title="产品导入" fontSize="14px" @getFile="Productexport" types="file"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<a style="" class="Dowload" @click="proDowload">产品导入模板下载</a>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable @onRowClick="onRowClick" colnum=33 :tableData="tableData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
		<DialogFrom width="1020px" title="新增产品档案" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK">
			<div class="from">
				<template v-for="(item , index) of fromdataadd">
					<Commondropdownlist :key="index" ref="proadd" :radio="item.radio" :minleft="item.minleft"
						:maxleft="item.maxleft" :options="item.options" :btx="item.btx" :inputdata="item.inputdata"
						:title="item.title" :fontSize="item.fontSize" :color="item.color"
						:radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata"
						:disabled="item.disabled">
					</Commondropdownlist>
				</template>
			</div>
		</DialogFrom>
		<DialogFrom width="1020px" title="修改产品档案" :dialogVisible="dialogVisiblesedit" @cancel="canceledit"
			@dialogOK="dialogOKedit">
			<div class="from">
				<template v-for="(item , index) of fromdataedit">
					<Commondropdownlist ref="proupdate" :key="index" :minleft="item.minleft" :maxleft="item.maxleft"
						:radio="item.radio" :options="item.options" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1"
						:radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min"
						:max="item.max">
					</Commondropdownlist>
				</template>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条产品档案吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivate" @cancel="canceldeactivate"
			@dialogOK="dialogOKdeactivate" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要停用这条产品档案吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleEable" @cancel="canceldialogOKEable"
			@dialogOK="dialogOKEable" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要启用这条产品档案吗？</span>
		</Dialog>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import fromdata from '../fromData/add'
	import fromdataedit from '../fromData/edit'
	import Dialog from '../../../../components/dialog.vue'
	import Commondown from '../../../../components/common-down.vue'
	import CommonbtnUpLoad from '../../../../components/common-upload.vue'
	import {
		InventoryInfo,
		InventoryAdd,
		InventoryEdit,
		InventoryDelete,
		InventoryClassList,
		InventoryActive,
		InventoryDeActive,
		HelperComUnit,
		InventoryImport,
		InventoryDownloadTemplet,
		ManufacturerList
	} from '@/api/home'
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			Commondown,
			CommonbtnUpLoad
		},
		props: {
			tableData: {
				type: Array,
				default: []
			},
			total: {
				type: Number,
				default: 0
			}
		},
		data: function() {
			return {
				dialogVisibles: false,
				dialogVisiblesedit: false,
				dialogVisibledel: false,
				dialogVisibledeactivate: false,
				dialogVisiblesU8: false,
				dialogVisiblesU8d: false,
				rightboo: false,
				rowboo: false,
				dwonleft: false,
				dialogVisibleEable: false,
				dialogVisiblesdrjg: false,
				tableDatadrjg: [],
				title: '',
				username: '',
				name: '',
				ptype: '',
				fromdataadd: [],
				fromdataedit: [],
				invCode: "",
				invAddCode: "",
				invName: "",
				invClass: "",
				from: {
					invCode: "",
					invAddCode: "",
					invName: "",
					invClass: "",
					unitName: "",
					invStd: "",
					invDescribe: "",
					storageCondition: "",
					registrationNo: "",
					productionLicenseNo: "",
					nationABCSort: "",
					isBatchManagement: "",
					isQGManagement: "",
					refCost: "",
					refPrice: "",
					standardCost: "",
					leveL1: "",
					leveL1_5: "",
					leveL2: "",
					leveL3: "",
					leveL4: "",
					actived: "",
					MFCode: ""
				},
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					setting: false
				},
			}
		},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			this.ManufacturerList()
			let data = JSON.parse(localStorage.getItem("MenusData"))
			let MenuID = this.$route.query.MenuID
			//console.log(data.Menus[0].Nodes[1], "data")
			data.Menus[0].Nodes.map((item, index) => {
				if (item.NodeID == 34) {
					item.Nodes.map((items, indexs) => {
						if (items.NodeID == 40) {
							this.qus = items.Nodes
						}
					})
				}
				// console.log(this.qus, 'this.qus');
			})
			if (this.qus) {
				this.qus.map((item, index) => {
					if (item.NodeName == 'add') {
						this.qx.add = true
					} else if (item.NodeName == 'edit') {
						this.qx.update = true
					} else if (item.NodeName == 'delete') {
						this.qx.del = true
					} else if (item.NodeName == 'stopif') {
						this.qx.del = true
					} else if (item.NodeName == 'assignment') {
						this.qx.assignment = true
					} else if (item.NodeName == 'enabled') {
						this.qx.enabled = true
					} else if (item.NodeName == 'skip') {
						this.qx.skip = true
					} else if (item.NodeName == 'reset') {
						this.qx.reset = true
					} else if (item.NodeName == 'setting') {
						this.qx.setting = true
					}
				})
			}
			//console.log("qux", this.qus)
		},
		methods: {
			// 生产厂商下拉
			async ManufacturerList() {
				let {
					code,
					data,
					message
				} = await ManufacturerList({

				})
				if (code == 0) {
					this.fromdataadd[21].options = []
					this.fromdataedit[21].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.MFCode,
							value: item.MFName
						}
						this.fromdataadd[21].options.push(obj)
						this.fromdataedit[21].options.push(obj)
					})
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					data,
					code
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.fromdataadd[2].options = []
					this.fromdataedit[2].options = []
					let arr = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						arr.push(obj)
					})

					this.fromdataadd[2].options = arr
					this.fromdataedit[2].options = arr
					//console.log(this.fromdataedit[2].options, 'arr')

				}
			},
			// 计量单位下拉
			async helperComUnit() {
				let {
					data,
					code
				} = await HelperComUnit({

				})
				if (code == 0) {
					this.fromdataadd[3].options = []
					this.fromdataedit[3].options = []
					let arr = []
					data.map((item, index) => {
						let obj = {
							key: item.Name,
							value: item.Name
						}
						arr.push(obj)
					})

					this.fromdataadd[3].options = arr
					this.fromdataedit[3].options = arr
				}
			},
			// 新增
			async inventoryAdd() {
				let {
					code,
					message
				} = await InventoryAdd({
					invCode: this.from.invCode,
					invAddCode: this.from.invAddCode,
					invName: this.from.invName,
					invClass: this.from.invClass,
					unitName: this.from.unitName,
					invStd: this.from.invStd,
					invDescribe: this.from.invDescribe,
					storageCondition: this.from.storageCondition,
					registrationNo: this.from.registrationNo,
					productionLicenseNo: this.from.productionLicenseNo,
					nationABCSort: this.from.nationABCSort,
					isBatchManagement: Number(this.from.isBatchManagement),
					isQGManagement: Number(this.from.isQGManagement),
					refCost: this.from.refCost,
					refPrice: this.from.refPrice,
					standardCost: Number(this.from.standardCost),
					leveL1: this.from.leveL1,
					leveL2: this.from.leveL2,
					leveL3: this.from.leveL3,
					leveL4: this.from.leveL4,
					leveL1_5: this.from.leveL1_5,
					actived: this.from.actived,
					MFCode: this.from.MFCode,
					GTIN: this.from.GTIN,
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '新增成功'
					});
					this.rowboo = false
					this.$parent.inventoryList()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 详情
			async inventoryInfo() {
				let {
					code,
					data
				} = await InventoryInfo({
					invCode: this.invCode,
				})
				if (code == 0) {
					this.$refs.proupdate[0].modelvalue = data.InvAddCode
					this.$refs.proupdate[1].modelvalue = data.InvName
					this.$refs.proupdate[2].modelvalue = data.InvClass
					this.$refs.proupdate[3].modelvalue = data.UnitName

					this.$refs.proupdate[4].modelvalue = data.InvStd
					this.$refs.proupdate[5].modelvalue = data.InvDescribe
					this.$refs.proupdate[6].modelvalue = data.StorageCondition
					this.$refs.proupdate[7].modelvalue = data.RegistrationNo

					this.$refs.proupdate[8].modelvalue = data.ProductionLicenseNo
					this.$refs.proupdate[9].modelvalue = data.NationABCSort
					this.$refs.proupdate[10].radios = data.IsBatchManagement + ""
					this.$refs.proupdate[11].radios = data.IsQGManagement + ""

					this.$refs.proupdate[12].modelvalue = data.RefCost
					this.$refs.proupdate[13].modelvalue = data.RefPrice
					this.$refs.proupdate[14].radios = data.Actived + ""
					this.$refs.proupdate[15].modelvalue = data.StandardCost

					this.$refs.proupdate[16].modelvalue = data.LEVEL1
					this.$refs.proupdate[17].modelvalue = data.LEVEL2
					this.$refs.proupdate[18].modelvalue = data.LEVEL3
					this.$refs.proupdate[19].modelvalue = data.LEVEL4
					this.$refs.proupdate[20].modelvalue = data.LEVEL1_5
					this.$refs.proupdate[21].modelvalue = data.MFCode
					this.$refs.proupdate[22].modelvalue = data.GTIN
				}
			},
			// 修改
			async inventoryEdit(datalist) {
				let {
					code,
					message
				} = await InventoryEdit({
					invCode: this.invCode,
					invAddCode: datalist[0].modelvalue,
					invName: datalist[1].modelvalue,
					invClass: datalist[2].modelvalue,
					unitName: datalist[3].modelvalue,
					invStd: datalist[4].modelvalue,
					invDescribe: datalist[5].modelvalue,
					storageCondition: datalist[6].modelvalue,
					registrationNo: datalist[7].modelvalue,
					productionLicenseNo: datalist[8].modelvalue,
					nationABCSort: datalist[9].modelvalue,
					isBatchManagement: datalist[10].radios,
					isQGManagement: datalist[11].radios,
					refCost: datalist[12].modelvalue,
					refPrice: datalist[13].modelvalue,
					actived: datalist[14].radios,
					standardCost: datalist[15].modelvalue,
					leveL1: datalist[16].modelvalue,
					leveL2: datalist[17].modelvalue,
					leveL3: datalist[18].modelvalue,
					leveL4: datalist[19].modelvalue,
					leveL1_5: datalist[20].modelvalue,
					MFCode: datalist[21].modelvalue,
					GTIN: datalist[22].modelvalue,
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '修改成功'
					});
					this.rowboo = false
					this.$parent.inventoryList()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 删除
			async inventoryDelete() {
				let {
					code,
					message
				} = await InventoryDelete({
					invCode: this.invCode,
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '删除成功'
					});
					this.rowboo = false
					this.$parent.inventoryList()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 启用
			async inventoryActive() {
				let {
					code,
					message
				} = await InventoryActive({
					InvCode: this.invCode
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '启用成功'
					})
					this.rowboo = false
					this.$parent.inventoryList()
				} else {
					this.$message({
						type: 'error',
						message: message
					})
				}
			},
			// 停用
			async inventoryDeActive() {
				let {
					code,
					message
				} = await InventoryDeActive({
					InvCode: this.invCode
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '停用成功'
					})
					this.rowboo = false
					this.$parent.inventoryList()
				} else {
					this.$message({
						type: 'error',
						message: message
					})
				}
			},
			commclick(type) {
				this[type] = true
			},
			onRowClick(val) {
				this.rowboo = true
				this.invCode = val.InvCode
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
			adduser() {
				this.dialogVisibles = true
				this.inventoryClassList()
				this.helperComUnit()
			},
			cancel() {
				this.dialogVisibles = false
			},
			dialogOK() {
				// this.from.invCode = this.$refs.proadd[2].modelvalue,
				this.from.invAddCode = this.$refs.proadd[0].modelvalue
				this.from.invName = this.$refs.proadd[1].modelvalue
				this.from.invClass = this.$refs.proadd[2].modelvalue
				this.from.unitName = this.$refs.proadd[3].modelvalue
				this.from.invStd = this.$refs.proadd[4].modelvalue
				this.from.invDescribe = this.$refs.proadd[5].modelvalue
				this.from.storageCondition = this.$refs.proadd[6].modelvalue
				this.from.registrationNo = this.$refs.proadd[7].modelvalue
				this.from.productionLicenseNo = this.$refs.proadd[8].modelvalue
				this.from.nationABCSort = this.$refs.proadd[9].modelvalue
				this.from.isBatchManagement = this.$refs.proadd[10].radios
				this.from.isQGManagement = this.$refs.proadd[11].radios
				this.from.refCost = this.$refs.proadd[12].modelvalue
				this.from.refPrice = this.$refs.proadd[13].modelvalue
				this.from.actived = this.$refs.proadd[14].radios
				this.from.standardCost = this.$refs.proadd[15].modelvalue
				this.from.leveL1 = this.$refs.proadd[16].modelvalue
				this.from.leveL2 = this.$refs.proadd[17].modelvalue
				this.from.leveL3 = this.$refs.proadd[18].modelvalue
				this.from.leveL4 = this.$refs.proadd[19].modelvalue
				this.from.leveL1_5 = this.$refs.proadd[20].modelvalue
				this.from.MFCode = this.$refs.proadd[21].modelvalue
				this.from.GTIN = this.$refs.proadd[22].modelvalue
				this.inventoryAdd()
				this.dialogVisibles = false
			},
			// 产品导入
			async inventoryImport(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await InventoryImport(formData)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: res.message
						})
						this.$parent.inventoryList()
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: 'warning',
							message: res.message
						})
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
						this.title = "导入结果"
						this.$message({
							type: 'error',
							message: res.message
						})
					}
					loading.close();
				}
			},
			Productexport(file) {
				this.inventoryImport(file)
			},
			async inventoryDownloadTemplet() {
				// 测试
				// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"
				let {
					data,
					code,
					message
				} = await InventoryDownloadTemplet({})
				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			proDowload() {
				this.inventoryDownloadTemplet()
			},
			update() {
				if (this.rowboo == true) {
					this.dialogVisiblesedit = true
					this.inventoryInfo()
					this.inventoryClassList()
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要修改的数据！'
				});

			},
			canceledit() {
				this.dialogVisiblesedit = false
			},
			dialogOKedit() {
				this.inventoryEdit(this.$refs.proupdate)
				this.dialogVisiblesedit = false
			},
			del() {
				if (this.rowboo == true) {
					this.dialogVisibledel = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要删除的数据！'
				});
			},
			canceldel() {
				this.dialogVisibledel = false
			},
			dialogOKdel() {
				this.inventoryDelete()
				this.dialogVisibledel = false
			},
			deactivate() {
				if (this.rowboo == true) {
					this.dialogVisibledeactivate = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要停用的数据！'
				});

			},
			canceldeactivate() {
				this.dialogVisibledeactivate = false
			},
			dialogOKdeactivate() {
				this.inventoryDeActive()
				this.dialogVisibledeactivate = false
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},
			Enable() {
				if (this.rowboo == true) {
					this.dialogVisibleEable = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要启用的数据！'
				});

			},
			canceldialogOKEable() {
				this.dialogVisibleEable = false
			},
			dialogOKEable() {
				this.inventoryActive()
				this.dialogVisibleEable = false
			},
			proExport() {
				this.$emit('proExport')
			},
			downs(index) {
				//console.log("index", index)
				if (index == 0) {
					this.dialogVisiblesU8 = true
				}
				if (index == 1) {
					this.dialogVisiblesU8d = true
				}
			},
			cancelU8() {
				this.dialogVisiblesU8 = false
			},
			dialogOKeditU8() {
				this.dialogVisiblesU8 = false
			},
			cancelU8d() {
				this.dialogVisiblesU8d = false
			},
			dialogOKeditU8d() {
				this.dialogVisiblesU8d = false
			},
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}
</style>